import React, { useEffect, useState } from "react";
import Modal, { ModalButton } from "../../Modal/Modal";
import DateFilter from "../../Input/DateFilter";
import { Statuses } from "../../Input/Statuses";

const FilterProductHistory = (props) => {
  const {
    displayModal,
    closeModal,
    isFiltering,
    filterProductHistory,
    id,
    filterSuccess,
    setFilterState,
    filterState,
  } = props;

  const status = [{ name: "Successful" }, { name: "Failed" }];

  const [state, setState] = useState({
    date: "",
    active: false,
    status: "",
    index: "",
  });

  const handleFilter = () => {
    const payload = {
      id: id,
      status: state.status && state.status.toLowerCase(),
      date: state.date,
    };
    setFilterState({
      ...filterState,
      filterValues: payload,
    });
    filterProductHistory(1, 10, payload);
  };

  useEffect(
    () => {
      if (filterSuccess) {
        closeModal("filterModal");
        setState({
          ...state,
          date: "",
          active: false,
          status: "",
          index: "",
        });
      }
    },
    // eslint-disable-next-line
    [filterSuccess]
  );

  return (
    <div>
      <Modal
        displayModal={displayModal}
        closeModal={closeModal}
        title={"Filter Product History"}
        width={"496px"}
      >
        <DateFilter
          label={"Date"}
          placeholder={"Select date"}
          state={state}
          name={"date"}
          setState={setState}
          success={filterSuccess}
        />

        <div className="top-spacer">
          <Statuses
            label={"Status"}
            state={state}
            options={status}
            setstate={setState}
            blue={false}
            numberPerRow={3}
          />
        </div>

        <ModalButton
          isLoading={isFiltering}
          text={"Apply Search"}
          onClick={() => handleFilter()}
          testId={"button"}
          loadingText={"Filtering..."}
          disabled={isFiltering || state.status === "" || state.date === ""}
        />
      </Modal>
    </div>
  );
};

export default FilterProductHistory;
